import type { CustomContentProps } from "notistack";
import { SnackbarContent, useSnackbar } from "notistack";
import { forwardRef } from "react";
import { Card } from "../../../components/Card";
import { useTranslation } from "react-i18next";

import { HugeiconsIcon } from "@hugeicons/react";
import { Message01Icon } from "@hugeicons-pro/core-stroke-rounded";
import type { IconSvgElement } from "@hugeicons/react";

interface NewMessageProps extends CustomContentProps {
  message: string;
  duration: number;
  onActionClick: () => void;
}

export const NewMessage = forwardRef<HTMLDivElement, NewMessageProps>(
  (props, ref) => {
    const { id, message, duration, onActionClick, ...other } = props;

    const { closeSnackbar } = useSnackbar();

    const { t } = useTranslation("common");

    return (
      <SnackbarContent ref={ref} role="alert" {...other} key={id}>
        <Card
          className="bg-white w-[330px] overflow-hidden rounded-xl"
          onClick={() => {
            onActionClick();
            closeSnackbar(id);
          }}
        >
          <div className="h-1.5 w-full">
            <div
              className="shrinking-timer h-1.5 bg-content-1000"
              style={{
                animationDuration: `${duration}ms`
              }}
            />
          </div>
          <div className="flex gap-4 px-5 pt-4 pb-6 items-center">
            <HugeiconsIcon
              icon={Message01Icon as IconSvgElement}
              className="text-content-1000 shrink-0"
              size="24"
            />
            <div>
              <h4 className="mb-2 text-content-1000 text-sm font-bold">
                {t("stream-chat.notification.title")}
              </h4>

              <p className="text-content-300 text-xs max-w-[180px] truncate">
                {message}
              </p>
            </div>
          </div>
        </Card>
      </SnackbarContent>
    );
  }
);

NewMessage.displayName = "NewMessage";
